/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import glamorous from 'glamorous';
import { get, mapValues, memoize } from 'lodash/fp';
import Button from 'app/components/commons/Button';
import InputField from 'app/components/commons/InputField';
import Responsive from 'app/components/responsive/Responsive';
import t from 'app/utils/translate';
import { updateUserData } from 'app/actions/userActions';

type Props = {
  defaultUsername: string,
  isSubmitting: boolean,
  onSubmit: Object => void,
  lightContent: boolean,
};

type State = {
  username: string,
  canSubmit: boolean,
};

const FormRow = glamorous.div(({ theme }) => ({
  margin: '0 -10px',
  [theme.mediaQuery.tabletLandscapeAndUp]: {
    display: 'flex',
  },
}));

const FormItem = glamorous.div(({ theme }) => ({
  padding: '0 10px',
  [theme.mediaQuery.tabletLandscapeAndUp]: {
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 1,
  },
}));

const Final = glamorous.div({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: '1rem',
});

class ProfileFormPxc extends React.Component<Props, State> {
  props: Props;

  state: State = {
    username: this.props.defaultUsername,
    canSubmit: false,
  };

  componentDidMount() {
    const { defaultUsername } = this.props;

    if (defaultUsername.startsWith('sportsfan_')) {
      this.setState({
        canSubmit: true,
      });
    }
  }

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { username } = this.state;

    onSubmit({
      name: username,
    });
  };

  setFormField = memoize((key: string) => (value: string) => {
    this.setState({
      [key]: value,
    });
  });

  render() {
    const {
      defaultUsername,
      isSubmitting,
      lightContent,
    } = this.props;

    const {
      username,
      canSubmit,
    } = this.state;

    return (
      <form>
        <FormRow>
          <FormItem>
            <InputField
              label={t('Username')}
              type="text"
              name="username"
              value={username}
              onChange={this.setFormField('username')}
              placeholder="Enter Username"
              lightContent={lightContent}
              disabled={!defaultUsername.startsWith('sportsfan_')}
            />
          </FormItem>
        </FormRow>
        <Responsive tabletPortrait tabletLandsape desktop>
          {isLargeScreen => (
            <Final>
              <Button onClick={this.handleSubmit} disabled={isSubmitting || !canSubmit} block={!isLargeScreen}>
                {t('Update profile')}
              </Button>
            </Final>
          )}
        </Responsive>
      </form>
    );
  }
}

const connector = connect(
  state => ({
    ...mapValues(x => x(state.user.currentUser), {
      defaultUsername: get('name'),
    }),
    isSubmitting: state.user.updatingUser,
    lightContent: !state.settings.darkMode,
  }),
  {
    onSubmit: updateUserData,
  },
);

export default connector(ProfileFormPxc);
